<template>
  <v-text-field
    :id="id"
    :rules="[urlRule, ...(rules || [])]"
    :readonly="readonly"
    v-model="value"
    :label="`${getLength(value)}/${maxLength} znaků`"
    variant="underlined"
    color="#78BE13"
  />
</template>

<script setup>
import { ref, watch, computed } from 'vue';

const props = defineProps({
  /**
   * Element ID passed to the input.
   */
  id: String,
  /**
   * URL validation rules.
   */
  rules: Array,
  /**
   * Read only flag.
   */
  readonly: Boolean,
  /**
   * URL string.
   */
  url: String,
  /**
   * Input label.
   */
  label: String,
  /**
   * Max URL length.
   */
  maxLength: Number,
});

const emit = defineEmits(['change']);

const value = ref(props.url);

const isURLValid = computed(() => {
  try {
    const parsedUrl = new URL(value.value);
    return ['http:', 'https:'].includes(parsedUrl.protocol);
  } catch {
    return false;
  }
});

const urlRule = (val) => !isURLValid.value ? 'Neplatný odkaz' : getLength(val) <= props.maxLength || 'Příliš dlouhý odkaz';

const getLength = (val) => {
  return val
    ? val.replace(/^https?:\/\//gi, '').replace(/\/$/gi, '').length
    : 0;
};

watch(value, (newValue) => {
  emit('change', newValue);
});

watch(
  () => props.url,
  (newVal) => {
    value.value = newVal;
  }
);
</script>

<style scoped>
</style>
